import { useSelector } from 'react-redux';
import { isAuthorised } from './user-utilities';
import Env from '../Env';
import { UserState } from 'types/UserState';

export function AccessVerifier(portalAccess: string[], accessRoles: string[]): boolean {
  const isAdminPortal = Env.isAdminPortal();
  const userStore: UserState = useSelector((state: any) => state.userStore);
  const loggedInUser = userStore.loggedInUser;
  const assignedGrandfatherClientNumber = userStore.assignedGrandfatherClientNumber;
  const portalType = userStore.portalType;

  const routePortalType = isAdminPortal ? 'admin' : portalType;

  const hasAccess = portalAccess?.includes(routePortalType) && (isAuthorised(loggedInUser, assignedGrandfatherClientNumber, [accessRoles]) || !accessRoles);

  return hasAccess;
}